module.exports = __webpack_public_path__ + "img/chevron-green.5b9affb3.svg";